window.initializeGoogleMap = function () {
    var mapOptions = {
            center: new google.maps.LatLng(55.740242, 37.503971),
            zoom: 13,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            panControl: false,
            zoomControl: true,
            scrollwheel: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            }
        },
        marker,
        markerOptions,
        map = new google.maps.Map(document.getElementById("map_canvas"),
            mapOptions);

    addMarker({
        map: map,
        title: "Выдача товара",
        content: "г. Москва, ул. Барклая, д. 6, проходная с вывеской Трубный завод<br>" +
        "пн-пт: с 11 до 20 часов<br>" +
        "сб, вскр: с 12 до 17 часов<br>",
        mapLink: null,
        mapLinkYandex: "http://maps.yandex.ru/?rtext=~55.740563%2C37.504079&sll=37.504697%2C55.740457&sspn=0.010085%2C0.003383&rtt=mt&rtn=0&rtm=atm&source=route&ll=37.504697%2C55.740457&spn=0.010085%2C0.003383&z=17&l=map",
        position: new google.maps.LatLng(55.740242, 37.503971)
    });
    var infoWindowOpened = null;

    function addMarker(markerOptions) {
        marker = new google.maps.Marker(markerOptions);

        contentString = '<div>' +
            '<div id="siteNotice">' +
            '</div>' +
            '<h2 id="firstHeading" class="firstHeading">' + marker.title + '</h2>' +
            '<div id="bodyContent">' +
            '<p>' + marker.content + '</p>' +
            ((typeof(marker.mapLink) != 'undefined' && marker.mapLink != null) ? '<p><a href="' + marker.mapLink + '" target="_blank">Как проехать? (Маршруты Google)</a></p>' : '') +
            ((typeof(marker.mapLinkYandex) != 'undefined' && marker.mapLinkYandex != null) ? '<p><a href="' + marker.mapLinkYandex + '" target="_blank">Как проехать? (Маршруты Яндекс)</a></p>' : '') +
            '</div>' +
            '</div>';

        var infoWindow = new google.maps.InfoWindow({
            content: contentString
        });

        google.maps.event.addListener(marker, 'click', function () {
            if (Y.Lang.isObject(infoWindowOpened)) {
                infoWindowOpened.close();
            }

            infoWindow.open(map, marker);

            infoWindowOpened = infoWindow;
        });

        infoWindow.open(map, marker);

        infoWindowOpened = infoWindow;
    }
};

window.initializeGoogleMapOdincovo = function () {
    var mapOptions = {
            center: new google.maps.LatLng(55.658735, 37.219574),
            zoom: 13,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            panControl: false,
            zoomControl: true,
            scrollwheel: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            }
        },
        marker,
        markerOptions,
        map = new google.maps.Map(document.getElementById("map_canvas_odincovo"),
            mapOptions);

    addMarker({
        map: map,
        title: "Выдача товара",
        content: "г. Одинцово, ул. Михаила Кутузова, д. 5а (ЖК Гусарская баллада, ТЦ Кочубей, ст. Пионерская)<br>" +
        "пн-пт: с 11 до 20 часов<br>" +
        "сб, вскр: с 12 до 20 часов<br>",
        mapLink: null,
        mapLinkYandex: "http://maps.yandex.ru/?rtext=~55.658735%2C37.219574&sll=37.219574%2C55.658735&sspn=0.010085%2C0.003383&rtt=mt&rtn=0&rtm=atm&source=route&ll=37.219574%2C55.658735&spn=0.010085%2C0.003383&z=17&l=map",
        position: new google.maps.LatLng(55.658735, 37.219574)
    });
    var infoWindowOpened = null;

    function addMarker(markerOptions) {
        marker = new google.maps.Marker(markerOptions);

        contentString = '<div>' +
            '<div id="siteNotice">' +
            '</div>' +
            '<h2 id="firstHeading" class="firstHeading">' + marker.title + '</h2>' +
            '<div id="bodyContent">' +
            '<p>' + marker.content + '</p>' +
            ((typeof(marker.mapLink) != 'undefined' && marker.mapLink != null) ? '<p><a href="' + marker.mapLink + '" target="_blank">Как проехать? (Маршруты Google)</a></p>' : '') +
            ((typeof(marker.mapLinkYandex) != 'undefined' && marker.mapLinkYandex != null) ? '<p><a href="' + marker.mapLinkYandex + '" target="_blank">Как проехать? (Маршруты Яндекс)</a></p>' : '') +
            '</div>' +
            '</div>';

        var infoWindow = new google.maps.InfoWindow({
            content: contentString
        });

        google.maps.event.addListener(marker, 'click', function () {
            if (Y.Lang.isObject(infoWindowOpened)) {
                infoWindowOpened.close();
            }

            infoWindow.open(map, marker);

            infoWindowOpened = infoWindow;
        });

        infoWindow.open(map, marker);

        infoWindowOpened = infoWindow;
    }
};


// WEBPACK FOOTER //
// ./assets/javascript/maps.js